const CHAT_ENTRY = {
    global: 'global',
    customerService: 'customerService',
    footer: 'footer',
    resume: 'resume',
    bccPlaceHolderApp: 'customerServiceChatApp',
    fraudErrCheckout: 'fraudErrCheckout',
    authenticate: 'AUTHENTICATED',
    selfIdentified: 'SELF_IDENTIFIED'
};

export { CHAT_ENTRY };
